import { configureStore } from '@reduxjs/toolkit';
import loginApi from './apis/loginApi';
import geoLocationApi from './apis/geoLocationApi';
import createAccountApi from './apis/createAccountApi';
import usersSlice from './usersSlice';
import passwordApi from './apis/passwordApi';
import contactVerifyApi from './apis/contactVerifyApi';
import jdmPasswordApi from './apis/jdmPasswordApi';

const store = configureStore({
    reducer: {
        [usersSlice.name]: usersSlice.reducer,
        [loginApi.reducerPath]: loginApi.reducer,
        [geoLocationApi.reducerPath]: geoLocationApi.reducer,
        [createAccountApi.reducerPath]: createAccountApi.reducer,
        [passwordApi.reducerPath]: passwordApi.reducer,
        [contactVerifyApi.reducerPath]: contactVerifyApi.reducer,
        [jdmPasswordApi.reducerPath]: jdmPasswordApi.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat([
            loginApi.middleware,
            geoLocationApi.middleware,
            createAccountApi.middleware,
            passwordApi.middleware,
            contactVerifyApi.middleware,
            jdmPasswordApi.middleware,
        ]),
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: {},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
